// create-account.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserAccount } from './user-account';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  run(userAccount: UserAccount, uri: string): Observable<any> {
    const url = `${this.baseUrl}/${uri}`;
    const jsonUserAccount = JSON.stringify(userAccount);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log('Making POST request to URL:', url);
    console.log('Request Headers:', headers);
    console.log('Request Body:', jsonUserAccount);
    return this.http.post(url, jsonUserAccount, { headers });
  }

  // Logout method to send email to backend
  logout(email: string): Observable<any> {
    const url = `${this.baseUrl}/logout`; // Adjust this endpoint if necessary
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const body = { email }; // Send only the email in the body
    return this.http.post(url, body, { headers });
  }

  verifyEmail(email: string, verificationCode: string): Observable<any> {
    const url = `${this.baseUrl}/verifyEmail`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { email, verificationCode };
    return this.http.post(url, body, { headers });
  }

  generateVerificationCode(email: string): Observable<any> {
    const url = `${this.baseUrl}/generateVerificationCode`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { email };
    return this.http.post(url, body, { headers });
  }
}
